import { Wrench, Sparkles, ShieldCheck, Activity, Lock, PauseCircle } from "lucide-react";

const MAIN = [
  {
    icon: Wrench,
    title: "Build",
    body: "Custom platforms, SaaS, mobile and web — working software every two weeks. Not slides, not mockups. Actual product you can put in front of users.",
  },
  {
    icon: Sparkles,
    title: "Intelligence",
    body: "AI where it earns its place: copilots that reduce data entry, document processing that reads what a person would, automation with a human in the loop.",
  },
  {
    icon: ShieldCheck,
    title: "Govern",
    body: "Meyar — Enterprise GRC and Cyber Security GRC. Policies, controls, risk registers and evidence, all in one system, mapped to the frameworks you have to answer for.",
  },
  {
    icon: Activity,
    title: "Run",
    body: "Monitoring, patching, releases and support under a written SLA. When your system misbehaves at midnight, there is a name and a number for that.",
  },
];

const SMALL = [
  { icon: Lock, title: "Fixed scope, fixed price", body: "Priced sprints for well-defined pieces of work. No surprises." },
  { icon: PauseCircle, title: "Pause any sprint", body: "If priorities change, pause the sprint. No penalties, no lock-ins." },
];

export function BuildEngine() {
  return (
    <section data-testid="build-engine-section" className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-20 lg:px-6 lg:py-28">
        <div className="max-w-3xl">
          <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">The Wafa Build Engine</div>
          <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-4xl lg:text-5xl">
            How we help.
          </h2>
          <p className="mt-4 max-w-2xl text-base text-wafa-ink/75 lg:text-lg">
            Four capabilities, one team. We do not hand you off between vendors. The people who
            design your platform are the same people who ship it and keep it running.
          </p>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {MAIN.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              data-testid={`build-engine-card-${title.toLowerCase()}`}
              className="group flex flex-col rounded-lg border border-wafa-deep/10 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25 hover:shadow-[0_20px_50px_-20px_rgba(14,79,58,0.25)]"
            >
              <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-md bg-wafa-cream/70 text-wafa-deep transition-colors group-hover:bg-wafa-primary group-hover:text-white">
                <Icon className="h-5 w-5" />
              </div>
              <div className="font-heading text-xl font-semibold text-wafa-deep">{title}</div>
              <p className="mt-3 text-sm leading-relaxed text-wafa-ink/75">{body}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 grid gap-5 md:grid-cols-2">
          {SMALL.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              data-testid={`build-engine-small-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="flex items-start gap-4 rounded-lg border border-wafa-deep/10 bg-wafa-cream/40 p-5"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-white text-wafa-deep">
                <Icon className="h-4 w-4" />
              </div>
              <div>
                <div className="font-heading font-semibold text-wafa-deep">{title}</div>
                <p className="mt-1 text-sm text-wafa-ink/75">{body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
